import type { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  color?: string
  width?: string
  height?: string
}

export function LopOutline({
  color = '#616161',
  width = '25',
  height = '24',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5859 3.75C7.58187 3.75 4.33594 6.99594 4.33594 11C4.33594 15.0041 7.58187 18.25 11.5859 18.25C15.59 18.25 18.8359 15.0041 18.8359 11C18.8359 6.99594 15.59 3.75 11.5859 3.75ZM2.83594 11C2.83594 6.16751 6.75345 2.25 11.5859 2.25C16.4184 2.25 20.3359 6.16751 20.3359 11C20.3359 15.8325 16.4184 19.75 11.5859 19.75C6.75345 19.75 2.83594 15.8325 2.83594 11Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7055 16.1197C16.9984 15.8268 17.4733 15.8268 17.7662 16.1197L22.1162 20.4697C22.4091 20.7626 22.4091 21.2374 22.1162 21.5303C21.8233 21.8232 21.3484 21.8232 21.0555 21.5303L16.7055 17.1803C16.4126 16.8874 16.4126 16.4126 16.7055 16.1197Z"
        fill={color}
      />
    </svg>
  )
}
